
/* injects from baggage-loader */

'use strict';

export default class ProductGroupController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/product-group/product-group.controller.js